<nav class="align-items-end desktop">
    <ul class="ps-0">
        <ng-container *ngFor="let route of getRoutes()">
            <ng-container *ngIf="isMenuItemDisplayed(route)">
                <!-- No child -->
                <ng-container
                        *ngIf="
            (!route.children ||
              (route.children && route.children.length === 0)) &&
            route.path !== 'administration'
          "
                >
                    <li
                            class="me-3"
                            [routerLink]="route.path"
                            [ngClass]="{'active': isRouteActive(route)}"
                    >
                        {{ route.data?.title | translate }}
                    </li>
                </ng-container>
                <!-- Has children -->
                <ng-container
                        *ngIf="
            route.children &&
            route.children.length > 0 &&
            route.path !== 'administration'
          "
                >
                    <li class="me-3" [matMenuTriggerFor]="menu" [ngClass]="{'active': isRouteActive(route)}">
                        {{ route.data?.title | translate }}
                    </li>
                    <mat-menu class="py-3 px-2" #menu="matMenu" [overlapTrigger]="false">
                        <ng-container *ngFor="let child of route.children">
                            <button
                                    mat-menu-item
                                    *ngIf="child.data?.title"
                                    [routerLink]="route.path + '/' + child.path"
                            >
                                {{ child.data?.title | translate }}
                            </button>
                        </ng-container>
                    </mat-menu>
                </ng-container>
                <!-- Specific for administration -->
                <ng-container *ngIf="route.path === 'administration'">
                    <li class="me-3" [matMenuTriggerFor]="menu" [ngClass]="{'active': isRouteActive(route)}">
                        {{ route.data?.title | translate }}
                    </li>
                    <mat-menu class="py-3 px-2" #menu="matMenu" [overlapTrigger]="false">
                        <ng-container *ngFor="let child of administrationRoutes">
                            <button
                                    mat-menu-item
                                    *ngIf="child.data?.title && hasAccess(child)"
                                    [routerLink]="route.path + '/' + child.path"
                            >
                                {{ child.data?.title | translate }}
                            </button>
                        </ng-container>
                    </mat-menu>
                </ng-container>
            </ng-container>
        </ng-container>
    </ul>
</nav>
<!-- Mobile Navigation -->
<nav class="mobile">
    <ul>
        <!-- Dynamic Menu Items for Mobile -->
        <ng-container *ngFor="let route of getRoutes()">
            <ng-container *ngIf="isMenuItemDisplayed(route)">
                <li>
                    <!-- Parent Route -->
                    <div
                            class="menu-item"
                            (click)="toggleSubmenu(route.path)"
                            [routerLink]="
              (!route.children || route.children.length === 0) && route.path !== 'administration' ? route.path : null
            "
                            [ngClass]="{'active': isRouteActive(route)}"
                    >
                        {{ route.data?.title | translate }}
                        <!-- Indicator for routes with children -->
                        <mat-icon
                                *ngIf="(route.children && route.children.length > 0) || route.path === 'administration'"
                                class="toggle-icon"
                        >
                            {{ isSubmenuOpen(route.path) ? "expand_less" : "expand_more" }}
                        </mat-icon>
                    </div>

                    <!-- Submenu for Child Routes (regular routes) -->
                    <ul
                            *ngIf="
              route.children &&
              route.children.length > 0 &&
              isSubmenuOpen(route.path) &&
              route.path !== 'administration'
            "
                            class="submenu"
                    >
                        <li *ngFor="let child of route.children" (click)="close()">
                            <a [routerLink]="route.path + '/' + child.path"
                            routerLinkActive="active">
                            {{ child.data?.title | translate }}
                            </a>
                        </li>
                    </ul>

                    <!-- Submenu for Administration -->
                    <ul
                            *ngIf="
              route.path === 'administration' &&
              isSubmenuOpen('administration')
            "
                            class="submenu"
                    >
                        <li *ngFor="let child of administrationRoutes" (click)="close()">
                            <a *ngIf="hasAccess(child)" [routerLink]="'administration/' + child.path"
                            routerLinkActive="active">
                            {{ child.data?.title | translate }}
                            </a>
                        </li>
                    </ul>
                </li>
            </ng-container>
        </ng-container>

        <!-- Logout Link -->
        <li
                *ngIf="userService.getUser() | async"
                (click)="close()"
                class="logout-link"
        >
            <mat-icon class="me-3" color="primary">logout</mat-icon>
            <a [routerLink]="'/auth/logout'" routerLinkActive="active">Logout</a>
        </li>
    </ul>
</nav>
